import { container, singleton } from "tsyringe";
import { BehaviorSubject, combineLatest, Observable, Subscription } from 'rxjs';
import { PTSocketService } from "./ptsocket.service";
import { PTApiService } from "./ptapi-service";
import { QnaQuestion } from "../models/qna";
import { map } from "rxjs/operators";

@singleton()
export class QnaService {
    // using DI in constructor would require to eject the app
    private ptSocketService = container.resolve(PTSocketService);
    private ptApiService = container.resolve(PTApiService);

    private questions$ = new BehaviorSubject<QnaQuestion[]>([]);
    private seenQuestionIds$ = new BehaviorSubject<string[]>([]);

    public get questionsObservable() { return this.questions$.asObservable(); }

    public get unseenPollsCountObservable(): Observable<number> {
        return combineLatest([this.questions$, this.seenQuestionIds$]).pipe(
            map(([questions, seenIds]) => questions.map(q => q.id).filter(id => !seenIds.includes(id)).length)
        );
    }

    public markQuestionIdsAsSeen(questionIds: string[]) {
        const newSeenIds = questionIds.filter(q => !this.seenQuestionIds$.value.includes(q));
        // Only trigger observable if there are newly seen qna ids
        if (newSeenIds.length > 0) {
            this.seenQuestionIds$.next([...this.seenQuestionIds$.value, ...newSeenIds]);
        }
    }

    public async fetchQuestions() {
        // const questions = await this.ptApiService.fetchQuestions();
        // this.questions$.next(questions.questions);
    }

    public bindToSocket() {
        const sub = new Subscription();

        const qnaEvents = this.ptSocketService.qnaEventsObservables;
        sub.add(qnaEvents.questionAddUpdateObservable.subscribe(ev => {
            console.log('[QnaService] questionAddUpdateObservable', ev);
            const existingQuestionIndex = this.questions$.value.findIndex(q => q.id === ev.qnaData.id);
            if (existingQuestionIndex > -1) {
                const questions = [...this.questions$.value];
                questions[existingQuestionIndex] = ev.qnaData;
                this.questions$.next(questions);
            } else {
                this.questions$.next([...this.questions$.value, ev.qnaData]);
            }
        }));

        sub.add(qnaEvents.questionDeleteUpdateObservable.subscribe(ev => {
            console.log('[QnaService] questionDeleteUpdateObservable', ev);
            this.questions$.next([...this.questions$.value.filter(q => q.id !== ev.qnaData.questionId)]);
        }));

        sub.add(qnaEvents.questionUpvoteUpdateObservable.subscribe(ev => {
            console.log('[QnaService] questionUpvoteUpdateObservable', ev);
            const existingQuestionIndex = this.questions$.value.findIndex(q => q.id === ev.qnaData.questionId);
            if (existingQuestionIndex > -1) {
                const questions = [...this.questions$.value];
                const q = Object.assign({}, questions[existingQuestionIndex]);
                q.upvoteCount = ev.qnaData.upvoteCount;
                questions[existingQuestionIndex] = q;
                this.questions$.next(questions);
            }
        }));

        sub.add(qnaEvents.answerUpdateObservable.subscribe(ev => {
            console.log('[QnaService] answerUpdateObservable', ev);
            const existingQuestionIndex = this.questions$.value.findIndex(q => q.id === ev.qnaData.questionId);
            if (existingQuestionIndex > -1) {
                const questions = [...this.questions$.value];
                const q = Object.assign({}, questions[existingQuestionIndex]);
                q.answerCount = ev.qnaData.answerCount;
                q.replyCount = ev.qnaData.replyCount;
                questions[existingQuestionIndex] = q;
                this.questions$.next(questions);
            }
        }));

        return sub;
    }
}
